import * as React from 'react';
import { useCallback, useEffect } from 'react';
import { EKeyboardKey } from '../types/EKeyboardKey';

export type TSetItemActionTypes = 'increment' | 'decrement' | 'last' | 'first';

export const useSuggestKeyboard = ({
  onEnter,
  onEscape,
  onKeyboardSetItem,
  suggestionsChildrenRef,
  listBoxRef,
}: {
  onEnter(): void;
  onEscape?(): void;
  onKeyboardSetItem(type: TSetItemActionTypes): void;
  suggestionsChildrenRef: React.RefObject<HTMLElement | null>;
  listBoxRef: React.RefObject<HTMLElement | null>;
}) => {
  const handleChildrenElementKeyDown = useCallback(
    (e: KeyboardEvent) => {
      switch (e.key) {
        case EKeyboardKey.ArrowUp:
          onKeyboardSetItem('decrement');
          break;

        case EKeyboardKey.ArrowDown:
          onKeyboardSetItem('increment');
          break;

        case EKeyboardKey.Home:
        case EKeyboardKey.PageUp:
          onKeyboardSetItem('first');
          break;

        case EKeyboardKey.End:
        case EKeyboardKey.PageDown:
          onKeyboardSetItem('last');
          break;

        case EKeyboardKey.Escape:
          onEscape?.();
          break;

        case EKeyboardKey.Enter:
          onEnter();
          break;
      }
    },
    [onEscape, onEnter, onKeyboardSetItem],
  );

  useEffect(() => {
    if (!suggestionsChildrenRef.current || !listBoxRef.current) {
      return;
    }

    const currentSuggestionsChildrenRef = suggestionsChildrenRef.current;
    const currentListBoxRef = listBoxRef.current;

    currentSuggestionsChildrenRef.addEventListener('keydown', handleChildrenElementKeyDown);
    currentListBoxRef.addEventListener('keydown', handleChildrenElementKeyDown);

    return () => {
      currentSuggestionsChildrenRef.removeEventListener('keydown', handleChildrenElementKeyDown);
      currentListBoxRef.removeEventListener('keydown', handleChildrenElementKeyDown);
    };
  }, [handleChildrenElementKeyDown, suggestionsChildrenRef, listBoxRef]);
};
